<q9-loading-placeholder
  *ngIf="showLoader"
  [isLoading]="loading"
  [label]="loadingCaption"></q9-loading-placeholder>

<router-outlet></router-outlet>
